import { Mail } from "lucide-react";
import { WhatsAppIcon } from "@/components/icons/TikTokIcon";
import { useLang } from "@/lib/i18n";

export const CONTACT_WA_NUMBER = "970594390271";   // +970 59 439 0271 (personal chat — separate from the WhatsApp channel)
export const CONTACT_EMAIL = "alisalemps.com@gmail.com";

/** Direct-contact buttons: green WhatsApp chat + outlined e-mail. Used on the contact page and in the footer. */
export default function ContactButtons({ compact = false, testPrefix = "contact" }) {
    const { t } = useLang();
    const waHref = `https://wa.me/${CONTACT_WA_NUMBER}?text=${encodeURIComponent(t("waPrefill"))}`;
    const mailHref = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(t("emailSubject"))}`;
    const base = `inline-flex items-center justify-center gap-2 rounded-[10px] font-bold min-h-[48px] px-5 transition-[background-color,border-color,color,transform] duration-150 active:scale-[.98] ${compact ? "text-sm" : "text-[15px]"}`;
    return (
        <div className={`flex flex-col sm:flex-row gap-3 ${compact ? "" : "sm:gap-4"}`} data-testid={`${testPrefix}-buttons`}>
            <a href={waHref} target="_blank" rel="noopener noreferrer" className={`${base} bg-[#25D366] hover:bg-[#1ebe5b] text-white shadow-sm`} data-testid={`${testPrefix}-whatsapp-btn`}>
                <WhatsAppIcon className="w-5 h-5" /> <span>{t("waBtn")}</span>
            </a>
            <a href={mailHref} className={`${base} border-[1.5px] border-gray-300 dark:border-gray-600 text-brand-black dark:text-gray-100 hover:border-brand-red hover:text-brand-red`} data-testid={`${testPrefix}-email-btn`}>
                <Mail className="w-5 h-5" /> <span>{t("emailBtn")}</span>
            </a>
        </div>
    );
}
